/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

module.exports = {
    uiDefaults: {
        searchRequest:   '',
        sortOrder:       'number',
        favoritesActive: false
    }
};
